// Components
import { useContext } from 'react';
import { ConfigContext, SMPContainer, SMPFlex, SMPImage, SMPText } from '../../../index';

export interface IGroupSectionTitleProps {
  image?: string;
  title?: string;
  url?: string;
  urlTarget?: string;
  handleClick?: () => void;
  urlTitle?: string;
}

export const GroupSectionTitle = ({ url, urlTarget, title, handleClick, urlTitle, image }: IGroupSectionTitleProps): JSX.Element => {
  const { dataLabels } = useContext(ConfigContext);

  return (
    <SMPContainer size='4' variant='groupSectionTitleContainer' css={{ borderBottom: '2px solid $loContrast', p: 'unset' }}>
      <SMPFlex grid variant='tournament' css={{ py: '$2', px: '$3', alignItems: 'end' }}>
        <SMPFlex align='center' justify='start' gap='sm'>
          {image && <SMPImage src={image} height='16px' width='22px' css={{ borderRadius: '$0' }} alt='Tournament logo' />}
          <a href={urlTitle} target={urlTarget} style={{ textDecoration: 'none' }}>
            <SMPFlex direction='row' justify='start' align='center'>
              <SMPText variant='contrast' size='2' weight='700'>
                {title}
              </SMPText>
            </SMPFlex>
          </a>
        </SMPFlex>
        {url && (
          <a href={url} target={urlTarget}>
            <SMPText
              size='2'
              onClick={handleClick}
              css={{
                textDecoration: 'underline',
                textDecorationColor: '$standingsLinkColor',
                marginLeft: '$2_5',
                color: '$standingsLinkColor',
              }}
            >
              {dataLabels?.standings ?? 'Standings'}
            </SMPText>
          </a>
        )}
      </SMPFlex>
    </SMPContainer>
  );
};
